import { Directive, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AlarmRuleConditionDto } from '../../../../../../types/dtos/alarm-rule-condition.dto';
import { BaseRuleCondition } from './base-rule-condition';

@Directive()
export abstract class BaseCondition {
  @Input({required: true}) formGroup!: FormGroup;

  @Input() mode!: 'override' | 'edit' | 'view';

  @Input() condition: AlarmRuleConditionDto | undefined = undefined

  abstract ruleCondition: BaseRuleCondition;

  public isOverride(): boolean {
    if (this.mode !== 'override' && this.mode !== 'edit') {
      return false;
    }

    if (this.condition?.overrideConfig) return true;

    let getConfig: Record<string, unknown> | undefined = this.getConfig()
    if (!getConfig) return false;
    let currentValues: Record<string, unknown> = this.ruleCondition.formToConfig(this.formGroup.value)

    if (currentValues && getConfig) {
      return this.ruleCondition.isConfigDifference(currentValues, getConfig);
    }

    return false;
  }

  public getConfig(): Record<string, unknown> | undefined {
    return this.condition?.config as Record<string, unknown> | undefined;
  }

  public getOverrideConfig(): Record<string, unknown> | undefined {
    return this.condition?.overrideConfig;
  }

  public removeOverride(): void {
    let config: Record<string, unknown> | undefined = this.getConfig() as Record<string, unknown>

    this.formGroup.patchValue(this.ruleCondition.configToFrom(config))

    if (this.condition) this.condition.overrideConfig = undefined
  }
}